// ============================================================
// ByOurConsent.com -- Contact Page
// /contact
// ============================================================

import React from 'react';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';

const ContactPage = () => {
    return (
        <>
            <Helmet>
                <title>Contact Us — By Our Consent</title>
            </Helmet>

            <Nav />

            <div style={{ background: '#1e2a3a', borderBottom: '2px solid #8b1a1a', padding: '2rem 1.5rem' }}>
                <div style={{ maxWidth: '660px', margin: '0 auto' }}>
                    <h1 style={{ fontSize: '34px', fontWeight: 600, color: '#e8dfc8', fontFamily: "'EB Garamond', Georgia, serif" }}>
                        Contact us
                    </h1>
                    <p style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#8a9aaa', marginTop: '8px' }}>
                        We're here to help. Reach out and we'll respond as quickly as we can.
                    </p>
                </div>
            </div>

            <div style={{ maxWidth: '660px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

                {/* General inquiries */}
                <div style={{ background: '#f5f0e8', border: '0.5px solid #c8beaa', borderLeft: '3px solid #8b1a1a', borderRadius: '4px', padding: '1.5rem', marginBottom: '1rem' }}>
                    <div style={{ fontSize: '17px', fontWeight: 600, color: '#1e2a3a', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '6px' }}>
                        General inquiries
                    </div>
                    <div style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.7, marginBottom: '10px' }}>
                        Questions about membership, content, chapters, or the platform in general.
                    </div>
                    <a href="mailto:info@byourconsent.com" style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#8b1a1a', textDecoration: 'none', fontWeight: 600 }}>
                        info@byourconsent.com
                    </a>
                </div>

                {/* Store / orders */}
                <div style={{ background: '#f5f0e8', border: '0.5px solid #c8beaa', borderLeft: '3px solid #8b1a1a', borderRadius: '4px', padding: '1.5rem', marginBottom: '1rem' }}>
                    <div style={{ fontSize: '17px', fontWeight: 600, color: '#1e2a3a', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '6px' }}>
                        Store & orders
                    </div>
                    <div style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.7, marginBottom: '10px' }}>
                        Questions about your order, shipping status, or a damaged / defective item.
                        Please include your order number in your message.
                    </div>
                    <a href="mailto:support@byourconsent.com" style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#8b1a1a', textDecoration: 'none', fontWeight: 600 }}>
                        support@byourconsent.com
                    </a>
                </div>

                {/* Response time */}
                <div style={{ padding: '1.25rem', background: '#ede8dc', border: '0.5px solid #c8beaa', borderRadius: '4px', fontSize: '13px', fontFamily: 'sans-serif', color: '#6a7080', lineHeight: 1.6 }}>
                    <strong style={{ color: '#1e2a3a' }}>Response time:</strong> We aim to respond to all inquiries within 2 business days.
                    For urgent store issues, please include your order number and a photo if the item is damaged.
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ContactPage;
